import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./CustomDatePicker.css";

const CustomTimePicker = ({
  label,
  value,
  onChange,
  className = "ba-input",
  disabled = false,
  error = false,
  helperText = "",
  fullWidth = true,
  placeholder = "Select time",
  slotProps: externalSlotProps,
  ...otherProps
}) => {
  // Helper function to convert value to dayjs
  const getDayjsValue = (val) => {
    if (!val) return null;
    if (dayjs.isDayjs(val)) return val;
    if (typeof val === "string") {
      // Handle time string formats like "HH:mm" or "HH:mm:ss"
      const parsed = dayjs(val, "HH:mm");
      return parsed.isValid() ? parsed : null;
    }
    if (val instanceof Date) {
      const parsed = dayjs(val);
      return parsed.isValid() ? parsed : null;
    }
    return null;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label={label}
        value={getDayjsValue(value)}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        disabled={disabled}
        slotProps={{
          ...externalSlotProps,
          textField: {
            fullWidth: fullWidth,
            error: error,
            helperText: helperText,
            placeholder: placeholder,
            ...externalSlotProps?.textField,
            className: [className, "ashtang-date-field", externalSlotProps?.textField?.className]
              .filter(Boolean)
              .join(" "),
          },
          popper: {
            ...externalSlotProps?.popper,
            className: ["ashtang-date-popper", externalSlotProps?.popper?.className]
              .filter(Boolean)
              .join(" "),
            sx: {
              zIndex: 9999,
              ...externalSlotProps?.popper?.sx,
            },
          },
          desktopPaper: {
            ...externalSlotProps?.desktopPaper,
            className: ["ashtang-date-paper", externalSlotProps?.desktopPaper?.className]
              .filter(Boolean)
              .join(" "),
          },
          mobilePaper: {
            ...externalSlotProps?.mobilePaper,
            className: ["ashtang-date-paper", externalSlotProps?.mobilePaper?.className]
              .filter(Boolean)
              .join(" "),
          },
        }}
        {...otherProps}
      />
    </LocalizationProvider>
  );
};

export default CustomTimePicker;

